import axios from 'axios';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';

import myAxiosInstance from '../services/MyAxios';

import DateSelectRange from './DateSelectRange';

export default function DateSelect({
    url,
    setData,
    defaultRange,
    defaultStartDate,
    defaultEndDate,
    setStartDay,
    setEndDay,
    setIsLoading,
}) {
    const [range, setRange] = useState('today');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const requestController = useRef(new AbortController());

    useEffect(updateData, [startDate, endDate]);

    useEffect(() => {
        return () => requestController.current.abort();
    }, []);

    useEffect(() => {
        if (defaultStartDate) {
            setRange(defaultRange);
            setStart(defaultStartDate);
            setEnd(defaultEndDate);
        } else {
            setRange('today');
            setStart(moment().startOf('day'));
            setEnd(moment().endOf('day'));
        }
    }, [defaultStartDate, defaultEndDate]);

    function setStart(date) {
        if (setStartDay) {
            setStartDay(date);
        }
        setStartDate(date);
    }

    function setEnd(date) {
        if (setEndDay) {
            setEndDay(date);
        }
        setEndDate(date);
    }

    function updateData() {
        if (!startDate) {
            return;
        }

        let params = {}; // all-time filter
        if (startDate.isValid()) {
            if (endDate) {
                params = {
                    start_date: startDate.format(),
                    end_date: endDate.format(),
                };
            } else {
                params = { single_date: startDate.format() };
            }
        }
        if (setIsLoading) {
            setIsLoading(true);
        }
        myAxiosInstance
            .get(url, {
                params,
                signal: requestController.current.signal,
            })
            .then((response) => {
                if (setIsLoading) {
                    setIsLoading(false);
                }
                setData(response.data);

            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                    return;
                }

                setIsLoading?.(false);
                console.error('Error fetching data:', error);
            });
    }

    return (
        <DateSelectRange
            range={range}
            setRange={setRange}
            startDate={startDate}
            setStartDate={setStart}
            endDate={endDate}
            setEndDate={setEnd}
        />
    );
}
